<template>
  <section class="page">
    <div class="page-content">
      <div class="top-image">
        <img v-show="imgShow" class="animated slideInLeft" src="@/assets/img/page2.png"/>
      </div>
      <div class="introduction">
        <h2 class="subtitle">应用价值</h2>
        <p class="detailed">
          <span>
            1）远程监控：实现供电远程集中智能化监控和管理，优化值守人员配置，提高电力能源管控水平；
          </span>
          <br/>
          <span class="introduction-text">
            2）节能降耗：通过监视各用电设备的用能状况，分析设备运行效率，优化用电节能方案，降低设备自身损耗；
          </span>
          <br/>
          <span class="introduction-text">
            3）标准化作业：规范基层员工标准化作业水平，通过智能软件应用，对人员作业进行规范化管理，有效提升公司各部门各业务间的协同与效率；
          </span>
          <br/>
          <span class="introduction-text">
            4）一体化运维：基于现代化基础设备，打造电力运维管理的信息一体化平台。基于物联网、大数据、移动互联网等技术对电力能源进行集中管控；
          </span>
          <br/>
          <span class="introduction-text">
            5）安全管理：通过视频辅助操作、作业流程的模块化设计，确保运行维护检修人员按照电力安全规范作业；
          </span>
        </p> 
        <button class="more" @click="GoToDeploy">了解更多</button>
      </div>
      <div class="bottom-image">
        <img v-show="imgShow" class="animated slideInLeft" src="@/assets/img/page2.png"/>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "page",
  data() {
    return {
      imgShow: false
    }
  },
  methods: {
    onScroll() {
      let top = document.documentElement.scrollTop || document.body.scrollTop || window.pageYOffset
      if (top >= 2050) {
        this.imgShow = true
      } else {
        this.imgShow = false
      }
    },
    /**
     * 箭头点击跳页面
     */
    GoToDeploy () {
      this.$router.push({path: '/deploy', query: { mark: 1 }})
    }
  },
  mounted(){
    window.addEventListener('scroll', this.onScroll)
  },
  destroyed(){
    window.removeEventListener('scroll', this.onScroll)
  }
}
</script>

<style lang="scss" scoped>
.page {
  // background-color: #ffffff;
   background-color: #f9f6f6;
   padding: 70px 15px;
}

.page-content {
  display: flex;
  align-items: center;
  position: relative;
  width: 100%;
  margin-right: auto;
  margin-left: auto;

  @media (min-width: 576px) {
    max-width: 540px;
  }

  @media (min-width: 768px) {
    max-width: 620px;
  }

  @media (max-width: 992px) {
    height: 100%;
    max-width: 540px;
    display: block;

    .introduction {
      padding: 0px;
      text-align: center;

      .detailed {
        text-align: left;
      }
    }

    .top-image {
      display: none;
    }

    .bottom-image {
      display: block;
      width: 100%;

      .animated {
        width: 100%;
        margin-top: 20px;
      }
    }
  }

  @media (min-width: 992px) {
    max-width: 860px;
  }

  @media (min-width: 1200px) {
    max-width: 1020px;
  }

  // ipad
  @media (width: 768px) and (height: 1024px) {
    .detailed {
      text-indent: 0 !important;
    }
  }
}

.introduction {
  padding-left: 30px;
  padding-right: 0px;
  text-align: left;

  .subtitle {
    margin: 0;
    color: #0e314c;
    font-size: 20px;
    font-weight: 500;
  }

  .detailed {
    color: #6084a4;
    line-height: 1.9;
    font-size: 13px;
    margin-top: 15px;
    margin-bottom: 20px;
  }

  .more {
    background-color: #e36cd9;
    box-shadow: 0 13px 27px 0 rgba(244, 134, 101, 0.25);
    color: #ffffff;
    border: none;
    padding: 12px 36px;
    position: relative;
    border-radius: 4px;
    z-index: 1;
    text-transform: uppercase;
    -webkit-transition: 0.5s;
    transition: 0.5s;
    font-weight: 600;
    font-size: 13px;
    cursor: pointer;
  }
}

.bottom-image {
  display: none;
}

.image {
  position: relative;
  text-align: center;
  flex: 0 0 42%;
  max-width: 50%;
  padding: 0 30px;
  animation: mymove 5s infinite;
  animation-iteration-count: 1;
  -webkit-animation: mymove 5s infinite; /*Safari and Chrome both*/
  
  @keyframes mymove {
    from {
      top: 0px;
    }

    to {
      top: 200px;
    }
  }
  @-webkit-keyframes mymove /*Safari and Chrome*/ {
    from {
      top: 0px;
    }

    to {
      top: 200px;
    }
  }
  
  img {
    max-width: 100%;
    height: auto;
  }
}
</style>